import { StatusBadge } from '../StatusBadge';
import styles from './StudyCardHeader.module.css';

interface StudyCardHeaderProps {
  studyTypeName: string;
  isLatest: boolean;
  hasDraft: boolean;
}

export default function StudyCardHeader({
  studyTypeName,
  isLatest,
  hasDraft,
}: StudyCardHeaderProps) {
  return (
    <div className={styles.header}>
      <h4 className={styles.title}>{studyTypeName}</h4>
      {isLatest && <StatusBadge variant="info" label="Latest" />}
      {hasDraft && !isLatest && (
        <StatusBadge variant="warning" label="In Progress" />
      )}
    </div>
  );
}
